import { IAppState } from '../../../../../AppModulesWrapper';

import { EMoneySource } from '../../../../types/reducers/user';
import { selectPlacingMoneySource } from '../../moneySources/selectors';

export const selectIsMasterMoneySource = (state: IAppState): boolean => {
  const {
    user: { isSubAgent },
  } = state.servicePickerWidgetV2;

  const placingMoneySource = selectPlacingMoneySource(state);

  return isSubAgent && placingMoneySource === EMoneySource.Master;
};
